<template>
    <div>
        <v-btn prepend-icon="mdi-account-cancel" rounded="lg" block class="gradient-color-primary" @click="openDialog">
            Abonnement kündigen
        </v-btn>
        <v-dialog rounded="lg" v-model="dialog" max-width="500px">
            <v-card :loading="loading" class="confirmation-wrapper">
                <v-card-title class="confirmation-header">Bestätigung</v-card-title>
                <v-card-text class="confirmation-info">
                    Bitte gebe "Fabi hat den Längsten" ein, um das Abonnement zu beenden.
                    <v-text-field class="confirmation-text" v-model="confirmationText" variant="underlined"
                        label="Hier eingeben" />
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" text @click="dialog = false">Abbrechen</v-btn>
                    <v-btn color="success" text @click="confirmCancelation">Bestätigen</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
    data() {
        return {
            dialog: false,
            confirmationText: ''
        };
    },
    computed: {
        ...mapState('agency', ['loading'])
    },
    props: {
        agency: {
            type: Object,
            required: true
        }
    },
    methods: {
        ...mapActions('agency', ['cancelSubscription', 'saveLog']),
        openDialog() {
            this.dialog = true;
        },
        async confirmCancelation() {
            try {
                const confirmationLowerCase = this.confirmationText.toLowerCase();
                if (confirmationLowerCase === 'fabi hat den längsten' || confirmationLowerCase === 'fabi hat den kürzesten') {
                    this.dialog = false;

                    const updatedAgency = await this.$store.dispatch('agency/cancelSubscription', { agencyId: this.agency._id });
                    if (updatedAgency) {
                        await this.$store.dispatch('agency/saveLog', {
                            agencyId: this.agency._id,
                            changes: [
                                {
                                    date: new Date(),
                                    description: `Abonnement beendet.`,
                                    user: this.$store.state.loginAndOut.name // Fetch the name of the admin from the state
                                }
                            ],
                        });

                    }
                } else {
                    alert('Bitte gebe "Fabi hat den Längsten" ein, um zu bestätigen.');
                }
            } catch (error) {
                console.error('Error Fehler beim Kündigen des Abonnements :', error);
                alert('Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.');
            }
        }
    }
}
</script>

<style lang="scss" scoped></style>